<template>
  <div class="make-up-detail">
    <div @click="handleClick">
      <slot></slot>
    </div>
    <el-dialog
      title="补课详情"
      :visible.sync="showMakeUpDetail"
      append-to-body
      :modal-append-to-body="false"
      width="650px"
    >
      <div class="lesson-detail">
        <img
          src="https://wowsite.musicwow.com/teaching_system_frontend/images/statistics/yes.png"
          alt=""
        />
        <p class="old-lesson">原课次</p>
        <!-- 原课次-补课中-打开弹框 -->
        <lesson-dialog
          :lid="oldLessonId"
          class="bu-ke-zhong"
          v-if="oldRollCallStudent.make_up_status == 2"
        >
          <p class="mwow-green" style="cursor: pointer">查看详情 >></p>
        </lesson-dialog>
        <!-- 原课次-补课完成-跳转点名详情 -->
        <p
          class="mwow-green"
          style="cursor: pointer"
          v-else
          @click="goRollCallDetails(oldRollCallId)"
        >
          查看详情 >>
        </p>
        <p class="xian"></p>
        <img
          src="https://wowsite.musicwow.com/teaching_system_frontend/images/statistics/yes.png"
          alt=""
        />
        <p class="old-lesson">补课课次</p>
        <!-- 补课课次-补课中-打开弹框 -->
        <lesson-dialog
          :lid="newLessonId"
          class="bu-ke-zhong"
          v-if="showlogDetail"
        >
          <p class="mwow-green" style="cursor: pointer">查看详情 >></p>
        </lesson-dialog>
        <!-- 补课课次-补课完成-跳转点名详情 -->
        <p
          class="mwow-green"
          style="cursor: pointer"
          v-if="oldRollCallStudent.make_up_status == 3"
          @click="goRollCallDetails(newRollCallId)"
        >
          查看详情 >>
        </p>
      </div>
      <div class="lesson-class">
        <!-- 原课次 -->
        <div class="lesson-info mar-right">
          <div class="lesson-info-in">
            签到状态：
            <span v-if="oldRollCallStudent.student_status == 1">到课</span>
            <span v-if="oldRollCallStudent.student_status == 2">迟到</span>
            <span v-if="oldRollCallStudent.student_status == 3">请假</span>
            <span v-if="oldRollCallStudent.student_status == 4">未到课</span>
          </div>
          <div class="lesson-info-in">
            班级名称：<span class="lesson-info-in-item">{{
              oldClassLesson.class.name || "-"
            }}</span>
          </div>
          <div class="lesson-info-in">
            授课教师：
            <span
              class="lesson-info-in-item"
              v-if="oldClassLesson.teacher.length > 0"
            >
              {{
                oldClassLesson.teacher
                  .map((item) => {
                    return item.name;
                  })
                  .join("、" || "-") || "-"
              }}
            </span>
            <span v-else>-</span>
          </div>
          <div class="lesson-info-in">
            排课课程：<span class="lesson-info-in-item">{{
              oldClassLesson.course.title || "-"
            }}</span>
          </div>
          <div class="lesson-info-in">
            上课时间：<span class="lesson-info-in-item">
              {{ oldClassLesson.date }}
              {{ getWeekDate(oldClassLesson.week_day) }}
              {{ oldClassLesson.start_time.slice(0, 5) }}
            </span>
          </div>
          <div class="lesson-info-in">
            点名时间：<span class="lesson-info-in-item">
              {{
                getTime(new Date(Number(oldClassLesson.roll_call_time + "000")))
              }}
            </span>
          </div>
          <div class="lesson-info-in">
            耗课数：<span class="lesson-info-in-item">{{
              oldRollCallStudent.real_consume_number
            }}</span>
          </div>
          <div class="lesson-info-in">
            课消金额：<span class="lesson-info-in-item"
              >¥ {{ oldRollCallStudent.consume_amount }}</span
            >
          </div>
        </div>
        <!-- 补课课次-已完成 -->
        <div
          class="lesson-info"
          v-if="
            newRollCallStudent != null && oldRollCallStudent.make_up_status == 3
          "
        >
          <div class="lesson-info-in">
            签到状态：
            <span v-if="newRollCallStudent.student_status == 1">到课</span>
            <span v-if="newRollCallStudent.student_status == 2">迟到</span>
            <span v-if="newRollCallStudent.student_status == 3">请假</span>
            <span v-if="newRollCallStudent.student_status == 4">未到课</span>
          </div>
          <div class="lesson-info-in">
            班级名称：<span class="lesson-info-in-item">{{
              newClassLesson.class.name || "-"
            }}</span>
          </div>
          <div class="lesson-info-in">
            授课教师：
            <span
              class="lesson-info-in-item"
              v-if="newClassLesson.teacher.length > 0"
            >
              {{
                newClassLesson.teacher
                  .map((item) => {
                    return item.name;
                  })
                  .join("、" || "-") || "-"
              }}
            </span>
            <span v-else>-</span>
          </div>
          <div class="lesson-info-in">
            排课课程：<span class="lesson-info-in-item">{{
              newClassLesson.course.title || "-"
            }}</span>
          </div>
          <div class="lesson-info-in">
            上课时间：<span class="lesson-info-in-item">
              {{ newClassLesson.date }}
              {{ getWeekDate(newClassLesson.week_day) }}
              {{ newClassLesson.start_time.slice(0, 5) }}
            </span>
          </div>
          <div class="lesson-info-in">
            点名时间：<span class="lesson-info-in-item">
              {{
                getTime(new Date(Number(newClassLesson.roll_call_time + "000")))
              }}
            </span>
          </div>
          <div class="lesson-info-in">
            耗课数：<span class="lesson-info-in-item">{{
              newRollCallStudent.real_consume_number
            }}</span>
          </div>
          <div class="lesson-info-in">
            课消金额：<span class="lesson-info-in-item"
              >¥ {{ newRollCallStudent.consume_amount }}</span
            >
          </div>
        </div>
        <!-- 补课课次 - 未到课 -->
        <div
          class="lesson-info"
          v-if="
            newRollCallStudent != null && oldRollCallStudent.make_up_status == 1
          "
        >
          <div class="lesson-info-in">
            签到状态：
            <span v-if="newRollCallStudent.student_status == 1">到课</span>
            <span v-if="newRollCallStudent.student_status == 2">迟到</span>
            <span v-if="newRollCallStudent.student_status == 3">请假</span>
            <span v-if="newRollCallStudent.student_status == 4">未到课</span>
          </div>
          <div class="lesson-info-in">
            班级名称：<span class="lesson-info-in-item">{{
              newClassLesson.class.name || "-"
            }}</span>
          </div>
          <div class="lesson-info-in">
            授课教师：
            <span
              class="lesson-info-in-item"
              v-if="newClassLesson.teacher.length > 0"
            >
              {{
                newClassLesson.teacher
                  .map((item) => {
                    return item.name;
                  })
                  .join("、" || "-") || "-"
              }}
            </span>
            <span v-else>-</span>
          </div>
          <div class="lesson-info-in">
            排课课程：<span class="lesson-info-in-item">{{
              newClassLesson.course.title || "-"
            }}</span>
          </div>
          <div class="lesson-info-in">
            上课时间：<span class="lesson-info-in-item">
              {{ newClassLesson.date }}
              {{ getWeekDate(newClassLesson.week_day) }}
              {{ newClassLesson.start_time.slice(0, 5) }}
            </span>
          </div>
          <div class="lesson-info-in">
            点名时间：<span class="lesson-info-in-item">
              {{
                getTime(new Date(Number(newClassLesson.roll_call_time + "000")))
              }}
            </span>
          </div>
          <div class="lesson-info-in">
            耗课数：<span class="lesson-info-in-item">{{
              newRollCallStudent.real_consume_number
            }}</span>
          </div>
          <div class="lesson-info-in">
            课消金额：<span class="lesson-info-in-item"
              >¥ {{ newRollCallStudent.consume_amount }}</span
            >
          </div>
        </div>
        <!-- 补课课次-待补课 -->
        <div class="lesson-info" v-if="newClassLesson === null">
          <div class="null-info">暂未补课</div>
        </div>
        <!--  补课课次-补课中 -->
        <div
          class="lesson-info"
          v-if="
            newClassLesson != null && oldRollCallStudent.make_up_status === 2
          "
        >
          <div class="lesson-info-in">
            班级名称：<span class="lesson-info-in-item">{{
              newClassLesson.class.name || "-"
            }}</span>
          </div>
          <div class="lesson-info-in">
            授课教师：
            <span
              class="lesson-info-in-item"
              v-if="newClassLesson.teacher.length > 0"
            >
              {{
                newClassLesson.teacher
                  .map((item) => {
                    return item.name;
                  })
                  .join("、" || "-")
              }}
            </span>
            <span v-else>-</span>
          </div>
          <div class="lesson-info-in">
            排课课程：<span class="lesson-info-in-item">{{
              newClassLesson.course.title || "-"
            }}</span>
          </div>
          <div class="lesson-info-in">
            上课时间：<span class="lesson-info-in-item">
              {{ newClassLesson.date }}
              {{ getWeekDate(newClassLesson.week_day) }}
              {{ newClassLesson.start_time.slice(0, 5) }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="lesson-warning"
        v-if="
          oldRollCallStudent.make_up_status === 3 || newRollCallStudent != null
        "
      >
        补课课次点名后，如耗课数数有误，可前往点名课次详情手动调整。
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { lessonRepairDetailApi } from "@/api/makeUpLessons";
import { dateFormat } from "@/utils/timeFormat";
import lessonDialog from "../../storeSchedule/lessonDialog.vue";

export default {
  components: {
    lessonDialog,
  },
  // @Prop() sid!: number;
  props: ["sid"],
  data() {
    return {
      showMakeUpDetail: false, // 显示详情弹框
      showlogDetail: true, // 显示查看详情
      oldClassLesson: {
        class: {
          name: "",
        },
        teacher: [],
        course: {
          title: "",
        },
        date: "",
        week_day: "",
        start_time: "",
        roll_call_time: "",
      },
      oldRollCallStudent: {
        student_status: "",
        consume_amount: "",
        real_consume_number: "",
        make_up_status: "",
      },
      newClassLesson: {
        class: {
          name: "",
        },
        teacher: [],
        course: {
          title: "",
        },
        date: "",
        week_day: "",
        start_time: "",
        roll_call_time: "",
      },
      newRollCallStudent: {
        student_status: "",
        consume_amount: "",
        real_consume_number: "",
        make_up_status: 3,
      },
      oldRollCallId: "", // 原课次点名id
      oldLessonId: 0, // 原课次-课次id
      newLessonId: 0, // 补课-课次id
      newRollCallId: "", // 补课-点名id
    };
  },
  methods: {
    handleClick() {
      this.showMakeUpDetail = true;
      this.init(this.sid);
    },
    init(id) {
      lessonRepairDetailApi({
        roll_call_student_id: id,
      }).then((res) => {
        if (res.error_code === 0) {
          this.oldClassLesson = res.data.primary_lesson.class_lesson;
          this.oldRollCallStudent = res.data.primary_lesson.roll_call_student;
          this.newClassLesson = res.data.repair_lesson.class_lesson;
          this.newRollCallStudent = res.data.repair_lesson.roll_call_student;
          this.oldRollCallId =
            res.data.primary_lesson.class_lesson.roll_call_id;
          this.oldLessonId = res.data.primary_lesson.class_lesson.lesson_id;
          if (res.data.repair_lesson.class_lesson) {
            this.newLessonId = res.data.repair_lesson.class_lesson.lesson_id;
            this.newRollCallId =
              res.data.repair_lesson.class_lesson.roll_call_id;
          }
          // 异常状态, 判断补课中, 没有返回补课信息时, 不显示查看详情
          if (res.data.repair_lesson.class_lesson == null) {
            this.showlogDetail = false;
          }
          // 正常情况, 补课完成, 不显示查看详情
          if (res.data.primary_lesson.roll_call_student.make_up_status == 3) {
            this.showlogDetail = false;
          }
        }
      });
    },
    getWeekDate(wd) {
      const week = ["日", "一", "二", "三", "四", "五", "六"];
      return `(周${week[wd]})`;
    },
    getTime(e) {
      const weekZh = ["日", "一", "二", "三", "四", "五", "六"];
      const v = "（周" + weekZh[e.getDay()] + "）";
      const format = dateFormat("YYYY-mm-dd HH:MM", e);
      return format.slice(0, 10) + v + format.slice(11);
    },
    goRollCallDetails(rld) {
      this.$router.push({
        name: "rollCallDetails",
        query: {
          id: rld,
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.make-up-detail {
  display: inline-block;
}
.lesson-detail {
  display: flex;
  align-items: center;
  .old-lesson {
    font-size: 16px;
    margin: 0 10px 0 16px;
    font-weight: 500;
  }
  .xian {
    width: 120px;
    height: 1px;
    background-color: #e7e8ea;
    margin-left: 22px;
    margin-right: 22px;
  }
}
.lesson-class {
  display: flex;
  margin-top: 16px;
  .lesson-info {
    padding: 0 9px 16px 16px;
    width: 300px;
    background: #f2f6fa;
    border-radius: 4px;
    .lesson-info-in {
      font-size: 12px;
      font-weight: 500;
      color: #5c5d5e;
      margin-top: 16px;
      opacity: 1;
      display: flex;
      span {
        flex: 1;
        width: 239px;
      }
    }
    .lesson-info-in-item {
      font-size: 12px;
      font-weight: 400;
    }
    .null-info {
      margin: 18px 0 0 18px;
      color: #5c5d5e;
    }
  }
}
.mar-right {
  margin-right: 22px;
}
.lesson-warning {
  color: #ffb940;
  font-weight: 500;
  margin-top: 20px;
}
.bu-ke-zhong {
  flex: none;
  text-align: left;
}
</style>
